import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles({
  redText: {
    color: 'red',
  },
  marginBottom: {
    marginBottom: '30px',
  },
  stepContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '20px',
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
  stepsAndMapContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: '20px',
    gap: '20px',
  },
  mapContainer: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
  },
});

export default useStyles;
